import { useParams } from '@tanstack/react-router'
import { useRecord } from '@/db/hooks'
import { taskKind, type TaskResource, type TaskSpec, type TaskStatus } from '@/kinds/task'
import { Gone } from './NotFound'

export const TaskView = () => {
  const { id } = useParams({ strict: false }) as { id: string }
  const task = useRecord<TaskSpec, TaskStatus>(id) as TaskResource | null | undefined
  if (task === undefined) return null
  if (!task || task.deleted_at || task.kind !== 'Task')
    return <Gone kind="task" deleted={!!task?.deleted_at} />
  const Detail = taskKind.Detail
  return <Detail resource={task} />
}
